class RevealButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.swatchesList = this.closest('.color-swatches');

    if (!this.swatchesList && this.dataset.target) {
      this.swatchesList = document.querySelector(this.dataset.target);
    }

    if (!this.swatchesList) {
      console.error('reveal-button: colour swatch list not found');
      return;
    }

    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.swatchesList.classList.add('open');
  }
}

window.customElements.define('reveal-button', RevealButton);
